import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';

//  root utility
import getters from './root/getters';
import actions from './root/actions';
import mutations from './root/mutations';

import { rootUrl } from '../common/index';

Vue.use(Vuex);
const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  key: 'stock',
});

export default new Vuex.Store({
  modules: {

  },
  state: {
    users: [],
    clients: [],  
    cart: [], 
    user: null,
    isLoggedIn: false,
    host: rootUrl,
    loader: false,
    btnLoader: false
  },
  mutations,
  actions,
  getters,
  plugins: [vuexLocal.plugin],
});
